// extracted by mini-css-extract-plugin
module.exports = {"cta":"cta_cta__s1gYg","twincle":"cta_twincle__ZgGdN"};